import serverVars from 'server-vars';
import thunk from 'redux-thunk';

/* Queries */
import { pdpRespRootQuery } from '../../queries/pdpRespRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { pdpRespPreviewPageReducer as pdpPreviewPage } from '../../reducers/pdpRespPreviewPageReducer';
import { pdpRespPrintReducer as pdpPrint } from '../../reducers/pdpRespPrintReducer';
import { pdpRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/pdpRespNotificationsReducer';
import { pdpRespSimilarItemsReducer as similarItems } from '../../reducers/pdpRespSimilarItemsReducer';

/* Components */
import { PdpRespLayout } from '../../pdp/PdpRespLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { storePdpVisit } from '../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';

/* Actions */
import { setIsPdpRespPreviewPage } from '../../actions/pdpRespPreviewPageActions';

/* Notifications */
import { pdpRespNotifications } from '../../pdp/PdpRespNotifications/pdpRespNotifications';

import { initializePrerenderedCheckout } from 'dibs-checkout/exports/prerender/initializePrerenderedCheckout';
import { initPdpDatadogRum } from '../../shared/helpers/initPdpDatadogRum';
import { pdpTypes } from '../../shared/helpers/pdpTypes';

const isPdpRespPreviewPage = serverVars.get('isPdpRespPreviewPage');

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    autoRunNotificationQueue: !isPdpRespPreviewPage,
    middleware: [thunk],
    notifications: pdpRespNotifications,
    reducers: {
        pdpPrint,
        pdpPreviewPage,
        sharedNotificationsReducer,
        similarItems,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(location.pathname);
if (itemId) {
    storePdpVisit({ itemId });
}

initPdpDatadogRum({ pdpType: pdpTypes.marketplace, device: 'resp' });

initializeDBL(options).then(async ({ store }) => {
    store.dispatch(setIsPdpRespPreviewPage({ isPdpRespPreviewPage }));
    createEntry({
        Container: PdpRespLayout,
        store,
        query: pdpRespRootQuery,
    });

    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    if (itemId) {
        await initializePrerenderedCheckout({
            isMobile: false,
            itemId,
            locale,
            messages,
        });
    }
});
